import * as THREE from "three";

const mod = () => {
  let object = null;
  const create = (texture, scale) => {
    const geometry = new THREE.BoxGeometry(1 * scale, 1 / 100000, 1.5 * scale);
    const material = new THREE.MeshBasicMaterial({
      map: texture,
      transparent: true,
    });
    object = new THREE.Mesh(geometry, material);
    console.log("Creating Position Reticle", object);
  };
  return {
    create,
    get: () => object,
  };
};

const PositionReticle = mod();
export default PositionReticle;
